import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.7863 7.63278C10.9201 7.79088 10.9003 8.0275 10.7422 8.16128L6.64786 11.6258H18.7493C18.9564 11.6258 19.1243 11.7937 19.1243 12.0008C19.1243 12.2079 18.9564 12.3758 18.7493 12.3758H6.64963L10.7422 15.8387C10.9003 15.9725 10.9201 16.2091 10.7863 16.3672C10.6525 16.5253 10.4159 16.5451 10.2578 16.4113L5.40447 12.3046C5.31043 12.2365 5.24927 12.1258 5.24927 12.0008C5.24927 11.8972 5.29125 11.8034 5.35913 11.7356C5.36667 11.728 5.37456 11.7207 5.38279 11.7137L10.2578 7.58874C10.4159 7.45496 10.6525 7.47468 10.7863 7.63278Z",
		fill: "currentColor"
	})
});
export default SvgArrowLeft;
